import { oc } from '@orpc/contract';
import { recentEstimatesInputSchema, recentEstimatesOutputSchema } from '../schemas/dashboard.schemas.js';
export const listRecentEstimatesContract = oc
    .route({
    method: 'GET',
    path: '/dashboard/recent-estimates',
    tags: ['Dashboard'],
    summary: 'The most recently updated estimates',
})
    .input(recentEstimatesInputSchema)
    .output(recentEstimatesOutputSchema);
//# sourceMappingURL=list-recent-estimates.contract.js.map